(function ($) {
	'use strict';

	$(function () {
		function disableNavButton(swiper, sliderContainer) {
			if (swiper.isBeginning) {
				$(".js-carousel-nav-prev", sliderContainer).addClass("is-disabled");
				$(".js-carousel-nav-prev", sliderContainer).attr("disabled", "disabled");
			} else {
				$(".js-carousel-nav-prev", sliderContainer).removeClass("is-disabled");
				$(".js-carousel-nav-prev", sliderContainer).removeAttr("disabled");
			}

			if (swiper.isEnd) {
				$(".js-carousel-nav-next", sliderContainer).addClass("is-disabled");
				$(".js-carousel-nav-next", sliderContainer).attr("disabled", "disabled");
			} else {
				$(".js-carousel-nav-next", sliderContainer).removeClass("is-disabled");
				$(".js-carousel-nav-next", sliderContainer).removeAttr("disabled");
			}
		}

		$('.js-stories-slider').each(function () {
			/* Slider Functionality */
			const sliderContainer = $(this);
			const sliderSystem = sliderContainer[0];
			const sliderEl = $('.swiper', sliderContainer)[0];
			const allSlides = [...sliderEl.querySelectorAll('.js-stories-carousel-slide')];
			const sliderNav = sliderSystem.querySelector('.carousel-nav');
			const firstFilter = sliderEl.dataset.firstFilter;
			let slidesWithIndexes = {};

			allSlides.forEach((slide, index) => {
				slidesWithIndexes[index] = {
					slide,
					filters: slide.getAttribute('data-filters')
				}
			});

			let activeFilter = firstFilter ? firstFilter : '*';

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				loop: false,
				slidesPerView: 1,
				navigation: false,
				spaceBetween: 20,
				breakpoints: {
					560: {
						slidesPerView: 2,
					},

					768: {
						slidesPerView: 2.5,
					},

					1024: {
						slidesPerView: 3,
					}
				},
				on: {
					afterInit: function () {
						const firstFilter = sliderEl.dataset.firstFilter;

						this.removeAllSlides();

						Object.keys(slidesWithIndexes).forEach(key => {
							if (slidesWithIndexes[key].filters.includes(firstFilter)) {
								this.addSlide(key, slidesWithIndexes[key].slide);
							}
						});

						this.updateSize();
						this.updateSlides();
						this.updateProgress();
						this.updateSlidesClasses();
						this.slideTo(0);
						this.scrollbar.updateSize();

						disableNavButton(this, sliderContainer);
					},

					slideChange: function () {
						disableNavButton(this, sliderContainer);
					},

					resize: function () {
						disableNavButton(this, sliderContainer);
					}
				},
			});

			$('.js-carousel-nav-next', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slideNext();
				});
			});

			$('.js-carousel-nav-prev', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slidePrev();
				});
			});

			$('.js-animated-fancy[data-fancybox]').fancybox({
				animationDuration: 350,
				animationEffect: 'amaze',
				backFocus: false,
				autoFocus: false,
				afterClose: function (instance) {
					const trigger = instance['$trigger'][0];
					const triggerParentSlide = trigger.closest('.js-stories-carousel-slide');

					const index = [...sliderEl.querySelectorAll('.js-stories-carousel-slide')].indexOf(triggerParentSlide);

					swiper.slideTo(index);
				}
			});

			/* Filter Functionality */
			if (sliderSystem.querySelectorAll('.js-stories-filter').length > 0) {
				const filters = [...sliderSystem.querySelectorAll('.js-stories-filter')];
				const filterText = JSON.parse(sliderSystem.querySelector('.js-stories-slider-content').dataset.descriptions);
				const leftContent = sliderSystem.querySelector('.js-stories-slider-content-left');
				const rightContent = sliderSystem.querySelector('.js-stories-slider-content-right');

				filters.forEach(filter => {
					const filterValue = filter.getAttribute('data-filter');

					filter.addEventListener('click', (ev) => {
						ev.preventDefault();
						let showNav = false;

						if (filterValue === activeFilter) {
							return false;
						}

						filters.forEach(nestedFilter => {
							nestedFilter.classList.remove('stories__filter--active');
						});

						filter.classList.add('stories__filter--active');

						leftContent.innerHTML = filterText[filterValue].left_column;
						rightContent.innerHTML = filterText[filterValue].right_column;

						swiper.removeAllSlides();

						if (filterValue === '*') {
							Object.keys(slidesWithIndexes).forEach(key => {
								swiper.addSlide(key, slidesWithIndexes[key].slide);
							});
						} else {
							Object.keys(slidesWithIndexes).forEach(key => {
								if (slidesWithIndexes[key].filters.includes(filterValue)) {
									swiper.addSlide(key, slidesWithIndexes[key].slide);
								}
							});
						}

						// Seen on https://codepen.io/ChaeEunMi/pen/GRgPoex
						swiper.updateSize();
						swiper.updateSlides();
						swiper.updateProgress();
						swiper.updateSlidesClasses();
						swiper.slideTo(0);
						swiper.scrollbar.updateSize();

						swiper.slides.forEach(slide => {
							if (!slide.classList.contains('swiper-slide--hidden')) {
								showNav = true;
							}
						});

						if (showNav) {
							sliderNav.classList.remove('carousel-nav--hidden');
						} else {
							sliderNav.classList.add('carousel-nav--hidden');
						}

						activeFilter = filterValue;
					});
				});
			}
		});
	});
})(jQuery, document, window);
